import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/statistic/index.js
// module id = 1053
// module chunks = 0